import cspPresetPack from '@yandex-int/csp-presets-pack'

export const CSP_VALUES = {
  NONE: "'none'",
  EVAL: "'unsafe-eval'",
  INLINE: "'unsafe-inline'",
  STRICT_DYNAMIC: "'strict-dynamic'",
  SELF: "'self'",
  DATA: 'data:',
  BLOB: 'blob:',
  SAMPLE: "'report-sample'",
} as const

export type CspValue = (typeof CSP_VALUES)[keyof typeof CSP_VALUES]

export const CSP = {
  FRAME: cspPresetPack.FRAME as 'frame-src',
  DEFAULT: cspPresetPack.DEFAULT as 'default-src',
  SCRIPT: cspPresetPack.SCRIPT as 'script-src',
  STYLE: cspPresetPack.STYLE as 'style-src',
  IMG: cspPresetPack.IMG as 'img-src',
  FONT: cspPresetPack.FONT as 'font-src',
  OBJECT: cspPresetPack.OBJECT as 'object-src',
  MEDIA: cspPresetPack.MEDIA as 'media-src',
  FRAME_ANCESTORS: cspPresetPack.FRAME_ANCESTORS as 'frame-ancestors',
  CONNECT: cspPresetPack.CONNECT as 'connect-src',
  WORKER: cspPresetPack.WORKER as 'worker-src',
  CHILD: cspPresetPack.CHILD as 'child-src',
  BASE_URI: cspPresetPack.BASE_URI as 'base-uri',
  MANIFEST: cspPresetPack.MANIFEST as 'manifest-src',
} as const

export type Directive = (typeof CSP)[keyof typeof CSP]

export const METRICA_DOMAINS = [
  'metrika.yandex.ru',
  'metrika.yandex.by',
  'metrika.yandex.com',
  'metrika.yandex.com.tr',
  'metrica.yandex.ru',
  'metrica.yandex.by',
  'metrica.yandex.com',
  'metrica.yandex.com.tr',
]

// NONE,EVAL,INLINE,STRICT_DYNAMIC,SELF,DATA,BLOB,SAMPLE
